import { useCallback } from "react";
const useToken = (authImplementation) => {
  return useCallback(async () => {
    try {
      const token = await authImplementation.getToken();
      return token;
    } catch (e) {
      console.error("Caught internal:", e);
      return null;
    }
  }, [authImplementation]);
};
export {
  useToken
};
